import { lazy } from "react"
import type { CustomRoute } from "@/shared/types"

const StatisticsComponent = lazy(async () => await import("@/pages/dashboard/control/statistics"))

export const controlStatisticsRoutes: CustomRoute = {
  path: "statistics",
  handle: { label: "Управление", i18Key: "control" },
  Component: StatisticsComponent
}
